import React, { useState } from 'react';
import { ConciliationGrid } from './ConciliationGrid';
import Select from 'react-select';
import { styleSelect } from '../../../../../rbts/assets/ts/_utils';
import { useObtenerDiasPorEvento } from '../../cortesias/hooks/CortesiasHook';

type Props = {};

const tipos = [
  { id: 1, value: 1, label: 'Puntos de venta' },
  { id: 2, value: 2, label: 'Juegos' },
];

const View: React.FC<Props> = ({}) => {
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const [strDate, setStrDate] = useState<string>('');

  const [idDia, setIdDia] = useState<number>(0);
  const [idTipo, setIdTipo] = useState<number>(0);
  const [diaSeleccionado, setDiaSeleccionado] = useState<any | null>([]);
  const [tipoSeleccionado, setTipoSeleccionado] = useState<any | null>([]);

  const { list: listadosDeDias, loadingRequest: cargandoDias } =
    useObtenerDiasPorEvento(reloadInfo);

  const handleSupplierOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setDiaSeleccionado(selectedOption);
      setIdDia(selectedOption.id);
      setStrDate(selectedOption.label);
    } else {
      setDiaSeleccionado(null);
      setIdDia(0);
      setStrDate('');
    }
  };
  const handleTipoOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setTipoSeleccionado(selectedOption);
      setIdTipo(selectedOption.id);
    } else {
      setTipoSeleccionado(null);
      setIdTipo(0);
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="d-flex flex-column flex-xl-row">
              <div className="flex-lg-row-fluid">
                <div className="card mb-6 mb-xl-9">
                  <div className="card-header border-0">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Búsqueda
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                        <div className="w-300px pe-5 fs-7 text-gray-700">
                          <div className="w-100 d-flex">
                            <label className="form-label w-auto">
                              Día administrativo:{' '}
                            </label>
                          </div>
                          <Select
                            options={listadosDeDias}
                            value={diaSeleccionado}
                            styles={styleSelect}
                            placeholder={'Seleccione'}
                            className="w-100"
                            isSearchable={true}
                            noOptionsMessage={() => {
                              return (
                                <span>{'No se encontraron registros'}</span>
                              );
                            }}
                            onChange={handleSupplierOnChange}
                            isLoading={cargandoDias}
                            isClearable
                            backspaceRemovesValue
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                        <div className="w-300px pe-5 fs-7 text-gray-700">
                          <div className="w-100 d-flex">
                            <label className="form-label w-auto">Tipo: </label>
                          </div>
                          <Select
                            options={tipos}
                            value={tipoSeleccionado}
                            styles={styleSelect}
                            placeholder={'Todos'}
                            className="w-100"
                            isSearchable={true}
                            noOptionsMessage={() => {
                              return (
                                <span>{'No se encontraron registros'}</span>
                              );
                            }}
                            onChange={handleTipoOnChange}
                            isClearable
                            backspaceRemovesValue
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="d-flex flex-column flex-xl-row">
              <div className="flex-lg-row-fluid">
                <div className="card mb-6 mb-xl-9">
                  <div className="card-header border-0">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-gray-800">
                        Conciliaciones realizadas
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <ConciliationGrid
                          reloadGrid={reloadInfo}
                          strDate={strDate}
                          idDia={idDia}
                          idTipo={idTipo}
                        ></ConciliationGrid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
